import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../@core/auth/auth.service';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { FarmDTO } from '../models/farm';


@Injectable({
  providedIn: 'root'
})
export class FarmsService {
  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public apiFarmsByIdGet(id: number): Observable<FarmDTO> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling apiFarmsByIdGet.');
    }

    return this.httpClient.get(`${this.basePath}/api/Farms/${encodeURIComponent(String(id))}`);
  }

  public apiFarmsGet(varietyId?: number, includeBlocks?: boolean, includeInactive?: boolean): Observable<Array<FarmDTO>> {

    let queryParameters = new HttpParams();
    if (varietyId !== undefined && varietyId !== null) {
      queryParameters = queryParameters.set('VarietyId', <any>varietyId);
    }

    if (includeBlocks !== undefined && includeBlocks !== null) {
      queryParameters = queryParameters.set('IncludeBlocks', <any>includeBlocks);
    }

    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('IncludeInactive', <any>includeInactive);
    }

    return this.httpClient.get<FarmDTO[]>(`${this.basePath}/api/Farms`, { params: queryParameters });
  }

  public apiFarmsPost(body?: FarmDTO): Observable<FarmDTO> {
    return this.httpClient.post<FarmDTO>(`${this.basePath}/api/Farms`, body);
  }


  public apiFarmsByIdPut(id: number, body?: FarmDTO): Observable<FarmDTO> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling apiFarmsByIdPut.');
    }

    return this.httpClient.put<FarmDTO>(`${this.basePath}/api/Farms/${encodeURIComponent(String(id))}`, body);
  }

  public apiFarmsByIdDelete(id: number): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling apiFarmsByIdDelete.');
    }

    return this.httpClient.delete(`${this.basePath}/api/Farms/${encodeURIComponent(String(id))}`);
  }

  // Get all farms for Users Farm Assignment 
  public getAllFarmsForUsers(): Observable<Array<FarmDTO>> {
    return this.httpClient.get<FarmDTO[]>(`${this.basePath}/api/Farms/GetFarmsForUsers`,
    );
  }

  public apiGetFarmsByIdsGet(ids: string): Observable<Array<FarmDTO>> {
    if (!ids) {
      throw new Error('Required parameter ids was null or undefined when calling apiGetFarmsByIdsGet.');
    }
    return this.httpClient.get<FarmDTO[]>(`${this.basePath}/api/Farms/GetFarmsByIds?ids=${encodeURIComponent(ids)}`);
  }



}
